import styled from "styled-components";
import { FloatButton } from "antd";
import { useContext, useState } from "react";
import { useAppSelector } from "../../hooks";
import { StoreDetailsDrawer } from "./StoreDetailsDrawer";
import { HelpDrawer } from "./HelpDrawer";
import { ViewContext } from "../../Contexts";

import { ellipsisVertical, informationCircleOutline, helpCircleOutline, logoInstagram, logoFacebook, logoTiktok } from "ionicons/icons";
import { IonIcon } from "@ionic/react";

export const FloatMenu = styled(BaseFloatMenu)`
`

interface IFloatMenu {
  className?: string
}

function BaseFloatMenu({className}: IFloatMenu) {

  const partner = useAppSelector((state) => state.store)
  const [showStoreInfoDrawer, setShowStoreInfoDrawer] = useState<boolean>(false)
  const [showHelpDrawer, setHelpDrawer] = useState<boolean>(false)
  const view = useContext(ViewContext);

  return (
    <>
      {
        partner.details &&
        <div className={className}>
          <FloatButton.Group trigger="click" style={{ right: 24, bottom: view === "web" ? 40 : 100 }} icon={<IonIcon icon={ellipsisVertical} />}>
            <FloatButton icon={<IonIcon icon={informationCircleOutline} />} onClick={() => setShowStoreInfoDrawer(true)} />
            {
              partner.details.facebookUrl &&
              <FloatButton icon={<IonIcon icon={logoFacebook} />} onClick={() =>  window.open(partner.details?.facebookUrl, '_blank')?.focus()} />
            }
            {
              partner.details.instagramUrl &&
              <FloatButton icon={<IonIcon icon={logoInstagram} />} onClick={() =>  window.open(partner.details?.instagramUrl, '_blank')?.focus()} />
            }
            {
              partner.details.tiktokUrl &&
              <FloatButton icon={<IonIcon icon={logoTiktok} />} onClick={() =>  window.open(partner.details?.tiktokUrl, '_blank')?.focus()} />
            }
            <FloatButton icon={<IonIcon icon={helpCircleOutline} />} onClick={() => setHelpDrawer(true)} />
          </FloatButton.Group>
          <StoreDetailsDrawer onClose={() => setShowStoreInfoDrawer(false)} open={showStoreInfoDrawer} />
          <HelpDrawer onClose={() => setHelpDrawer(false)} open={showHelpDrawer} />
        </div>
      }
    </>
  )
}